import { ContentCopyRounded, EditOutlined } from "@mui/icons-material";
import {
	Avatar,
	AvatarGroup,
	Box,
	CardContent,
	Grid,
	IconButton,
	Popover,
	Stack,
	Switch,
	Typography,
} from "@mui/material";
import { debounce } from "lodash";
import MUIDataTable from "mui-datatables";
import { useEffect, useMemo, useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { getAllList, UpdateGrapeList } from "../../apis/GrapeList";
import { notify } from "../Playoff/PlayListTable";
import { ToastContainer } from "react-toastify";
import { getCurrentUser } from "../../store/authentication/service";

export default function DataTable({ list_type }) {
	const [data, setData] = useState([]);
	const [page, setPage] = useState(0);
	const user = getCurrentUser();
	const [searchText, setSearchText] = useState("");

	const [count, setCount] = useState(0);
	const [rowsCount, setRowsCount] = useState(10);

	const handleSearchChange = useMemo(
		() =>
			debounce((searchText) => {
				setSearchText(searchText);
			}, 500),
		[],
	);

	useEffect(() => {
		getAllList(rowsCount, page + 1, list_type, searchText).then((res) => {
			setData(res.results);
			setCount(res.count);
		});
	}, [list_type, page, rowsCount, searchText]);

	const handleToggleActive = async (id, active) => {
		try {
			await UpdateGrapeList({ active }, id);

			notify(`List ${active ? "activated" : "deactivated"}`);

			// Refresh table
			// getData();
			getAllList(rowsCount, page + 1, list_type, searchText).then(
				(res) => {
					setData(res.results);
					setCount(res.count);
				},
			);
		} catch (error) {
			notify("Something went wrong", "error");
		}
	};

	const columns = [
		{
			name: "id",
			label: "Id",
			options: {
				filter: false,
				sort: true,
				setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
			},
		},
		{
			name: "slug",
			label: "Slug",
			options: {
				filter: false,
				sort: true,
				// setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Typography variant="p" component={"p"}>
								{value}
							</Typography>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},
		{
			name: "title",
			label: "Title",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value) => {
					return (
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								alignItems: "center",
							}}
						>
							<Typography variant="p" component={"p"}>
								{value}
							</Typography>

							<CopyToClipboard
								text={value}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Box>
					);
				},
			},
		},

		{
			name: "image",
			label: "Collage",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<Avatar
							alt="List Logo"
							variant="square"
							sx={{
								width: 100,
								height: 100,
								objectFit: "fill",
								borderRadius: 4,
							}}
							src={value?.file}
						/>
					);
				},
			},
		},
		{
			name: "description",
			label: "Description",
			options: {
				filter: false,
				sort: true,
				// setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },
				customBodyRender: (value) => {
					return (
						<Typography
							variant="p"
							sx={{
								textTransform: "capitalize",
							}}
						>
							{value}
						</Typography>
					);
				},
			},
		},

		{
			name: "products",
			label: "Products",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return (
						<AvatarGroup
							sx={{
								justifyContent: "center",
							}}
							total={value?.length}
							componentsProps={{
								additionalAvatar: {
									onClick: (e) => {
										console.log("yes");
										handlePopoverOpen(e, value);
									},
									sx: {
										cursor: "pointer",
										bgcolor: "primary.main",
									},
									title: "See all Results", // optional tooltip
								},
							}}
						>
							{value.slice(0, 3).map((p, i) => (
								<Avatar
									key={`prod-${i}`}
									alt={p.name}
									src={p.image.file}
								/>
								//<p>{p.image.file}</p>
							))}
						</AvatarGroup>
					);
				},
			},
		},
		{
			name: "list_category",
			label: "List Category",
			options: {
				filter: false,
				sort: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					// console.log("yes", value);
					return value.map((p, i) => (
						<Typography
							component={"p"}
							variant="p"
							key={`list-${i}`}
						>
							{p.name}
						</Typography>
					));
				},
			},
		},

		{
			name: "active",
			label: "Active",
			options: {
				filter: false,
				// sort: true,
				// setCellProps: () => ({ sx: { textAlign: "right" } }),
				// customBodyRender: (value, tableMeta, updateValue) => {
				// 	// console.log("yes", tableMeta);
				// 	return tableMeta.rowIndex + 1;
				// },

				customBodyRender: (value, tableMeta) => {
					const row = data[tableMeta.rowIndex];

					return (
						<Switch
							checked={value}
							color="primary"
							onChange={(e) =>
								handleToggleActive(row.id, e.target.checked)
							}
						/>
					);
				},
			},
		},

		{
			name: "",
			label: "Action",
			options: {
				filter: false,
				sort: true,
				viewColumns: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const { rowIndex } = tableMeta;
					const row = data[rowIndex];
					return (
						<Stack direction={"row"}>
							<IconButton
								color="primary"
								href={
									user?.user_type === 4
										? `/upload-playoff/grapelist/${row.id}/edit`
										: `/w86zjruk6q/grapelist/${row.id}/edit`
								}
							>
								<EditOutlined />
							</IconButton>

							<CopyToClipboard
								text={`https://www.grape.town/list/${row.slug}`}
								onCopy={() => notify("copied")}
							>
								<IconButton size="small" color="primary">
									<ContentCopyRounded />
								</IconButton>
							</CopyToClipboard>
						</Stack>
					);
				},
			},
		},
	];

	const options = {
		jumpToPage: true,
		selectableRows: "none",
		download: false,
		filter: false,
		// filterType: "multiselect",
		serverSide: true,
		print: false,
		count: count,
		page: page,
		rowsPerPage: rowsCount,
		rowsPerPageOptions: [10, 25, 100],
		onChangePage(currentPage) {
			setPage(currentPage);
		},
		onChangeRowsPerPage(numberOfRows) {
			setRowsCount(numberOfRows);
			setPage(0);
		},
		onSearchChange: handleSearchChange,
		onColumnSortChange: (changedColumn, direction) => {
			// setSortingValues(
			// 	direction === "desc" ? `-${changedColumn}` : `${changedColumn}`
			// );
			// setPage(0)
			// setSortFields(temp);
		},

		// onTableChange: (action, tableState) => {
		// 	switch (action) {
		// 		case "sort":
		// 			sortTable(tableState.page, tableState.sortOrder);
		// 			break;
		// 		default:
		// 			console.log("action not handled.");
		// 	}
		// },
	};

	const [anchorEl, setAnchorEl] = useState(null);

	const [selectedResults, setSelectedResults] = useState([]);

	const handlePopoverOpen = (event, results) => {
		setAnchorEl(event.currentTarget);
		setSelectedResults(results);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setSelectedResults([]);
	};
	const open = Boolean(anchorEl);

	return (
		<Grid container justifyContent="center">
			<Grid item md={12}>
				<ToastContainer />
				<MUIDataTable data={data} columns={columns} options={options} />
				<Popover
					open={open}
					anchorEl={anchorEl}
					onClose={handleClose}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
				>
					<CardContent>
						<Typography paragraph>Results:</Typography>
						<Box>
							{selectedResults?.map((product, i) => {
								return (
									<Stack
										key={`playoff-group-${i}`}
										direction="row"
										alignItems="center"
										gap={1}
									>
										<Avatar
											alt={
												product.name
													? product.name
													: product.title
														? product.title
														: ""
											}
											src={product?.image?.file}
										/>
										<Typography
											paragraph
											sx={{
												marginBottom: 0,
											}}
										>
											{product.name
												? product.name
												: product.title
													? product.title
													: ""}
										</Typography>
									</Stack>
								);
							})}
						</Box>
					</CardContent>
				</Popover>
			</Grid>
		</Grid>
	);
}
